export default "__VITE_PUBLIC_ASSET__7ea2ba1b__"